export const Marquee = ({ items, testId }) => (
  <div data-testid={testId} className="overflow-hidden border-y border-white/5 py-7" aria-hidden="true">
    <div className="marquee-track flex w-max items-center">
      {[...items, ...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-8 font-display text-2xl font-semibold tracking-tight text-[#2E323B] sm:text-3xl">
            {t}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#2563EB]/60" />
        </span>
      ))}
    </div>
  </div>
);
